var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6566 21.9994L13.6574 12L23.6566 2.00063C24.1141 1.54313 24.1141 0.800625 23.6566 0.343125C23.1991 -0.114375 22.4566 -0.114375 21.9991 0.343125L11.9999 10.3425L2.00076 0.343125C1.54327 -0.114375 0.801254 -0.114375 0.343294 0.343125C-0.114666 0.800625 -0.114197 1.54313 0.343294 2.00063L10.3425 12L0.343294 21.9994C0.123455 22.2192 0.000175804 22.5173 0.000175804 22.8286C0.000175804 23.4759 0.525166 24.0005 1.17203 24.0005C1.4828 24.0005 1.78092 23.8772 2.00076 23.6573L11.9999 13.658L21.9991 23.6573C22.2185 23.8772 22.5171 24.0009 22.8279 24.0005C23.1386 24.0005 23.4368 23.8772 23.6566 23.6573C24.1141 23.1998 24.1141 22.4578 23.6566 21.9998V21.9994Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.a88d184b85711788576b341f7c0c6cdc.svg";
export { ForwardRef as ReactComponent };